<template>  
  <v-container grid-list-lg class="ma-0 pa-0">
    <v-layout row>
      <v-flex xs12 md4>
        <form @submit.prevent="onsubmit">
        <v-card>                    
          <v-card-text>                  

            <v-text-field outlined dense
              label="Name"
              v-model="fm.name"
              append-icon="grade"
              type="text"
              :error="!!error.name.length"
              :error-messages="error.name"
            ></v-text-field> 

            <v-select outlined dense
              v-model="fm.mode"
              :items="modes"
              label="Mode"
              item-text="name"
              item-value="id"
              :error="!!error.mode.length"
              :error-messages="error.mode"
            ></v-select>

            <v-text-field outlined dense
              label="Tahun"
              v-model="fm.tahun"
              append-icon="event"
              type="text"
              :error="!!error.tahun.length"
              :error-messages="error.tahun"
              style="max-width:150px"
            ></v-text-field>            

            <v-select outlined dense
              v-model="fm.tingkat"
              :items="tingkats"
              label="Tingkat"
              item-text="name"
              item-value="id"
              :error="!!error.tingkat.length"
              :error-messages="error.tingkat"
            ></v-select>

            <v-autocomplete outlined dense
              v-model="fm.area_id"
              label="Area"
              :items="nodes"
              item-text="name"
              item-value="id"
              :loading="nodeLoading"
              @keyup="search"
            >
              <template v-slot:item="data">                
                <template>
                  <v-list-item-content>
                    <v-list-item-title v-html="data.item.name"></v-list-item-title>
                    <v-list-item-subtitle>{{ data.item.parent_name }}</v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </template>
            </v-autocomplete>                                  
          
            <v-text-field outlined dense
              label="Description"
              v-model="fm.description"
              append-icon="description"
              type="text"
              :error="!!error.description.length"
              :error-messages="error.description"
            ></v-text-field>

            <v-menu
              v-model="colorpicker"              
              :nudge-right="40"
              transition="scale-transition"
              offset-y              
            >
              <template v-slot:activator="{ on }">
                <v-text-field outlined dense                  
                  v-model="fm.color"
                  label="Color"
                  append-icon="invert_colors"                  
                  v-on="on"
                  style="width:200px;"
                  :background-color="fm.color"
                  hide-details
                ></v-text-field>
              </template>
              <v-color-picker v-model="fm.color"></v-color-picker>                
            </v-menu>
            
            <v-switch v-model="fm.status" :label="fm.status === 1?'Status:Active':'Status:Inactive'" :true-value="1" :false-value="0"></v-switch>          
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn type="submit" :color="isUpdate?'blue':'green'" :loading="loading" dark>{{isUpdate?'update':'create'}}</v-btn>
          </v-card-actions>
        </v-card>
        </form>   
      </v-flex>            
    </v-layout>
  </v-container>    
</template>

<script>
import { debounce } from 'lodash'
import Model from '@/app/models/master/Kompetisi'
const  model = new Model();

export default {
  data : () => ({  
    fm:{mode: null, name: null, tahun:null, tingkat:null, area_id:null, description:null, color:'#fff', status:1},
    error:{mode: [], name : [], tahun:[], tingkat : [], area_id:[], description:[], color:[], status:[]},
    loading: false,
    isUpdate: false,    
    mode: 0,        
    nodes: [], nodeLoading:false,
    colorpicker:false,
  }),
  computed:{
    modes(){
      let obj = this.$store.getters.DICTIONS.KompetisiMode;
      return Object.keys(obj).map(function(key) { return {id:parseInt(key), name: obj[key]}; });
    },
    tingkats(){
      let obj = this.$store.getters.DICTIONS.RegionLevel;
      return Object.keys(obj).map(function(key) { return {id:parseInt(key), name: obj[key]}; });
    }
  },
  watch:{
    'fm.area_id'(newId, oldId){
      if(oldId===null && newId !== null){
        model.node({id:newId}).then(data=>{
          this.nodes.push(data);
        })    
      }
    }
  }, 
  mounted(){
    if(this.$route.query.id){
      this.isUpdate = true;
      model.view({id:this.$route.query.id}).then(data=>{                
        Object.assign(this.fm, data);
        this.fm.area_id = String(this.fm.area_id);
      })
    }
  },
  methods: {
    search: debounce(function (e) {      
      this.readNodes(e.target.value)
    }, 800),

    readNodes(term){
      this.nodeLoading = true;
      model.nodes({q:term,level:this.fm.tingkat}).then(res=>{
        this.nodes = res.data;
        this.nodeLoading = false;
      })
    },

    onsubmit(){
      this.loading = true;  this.clearErrors();
      if(this.isUpdate){        
        model.update(this.fm, {id:this.fm.id}).then(res=>{this.responseSubmit(res)})
      } else {        
        model.create(this.fm).then(res=>{this.responseSubmit(res)})
      }
    },

    responseSubmit(res){
      this.loading = false;
      if(res.status === 200){
        window.getApp.$emit('showSnackbar', {text :'Data has been saved successfully', color: 'green', show:true});            
        this.$router.replace({name:'master/kompetisi'})                
      } else {
        this.validate(res.data);
      }
    },

    validate(data){      
      for(var i in data){        
        if(Array.isArray(this.error[data[i]['field']])){          
          this.error[data[i]['field']].push(data[i]['message']);
        }        
      }
    },

    clearErrors(){
      this.error.name    = [];
      this.error.type    = [];
      this.error.address = [];
      this.error.email   = [];
      this.error.node_id = [];      
    }
  },
}
</script>

<style>
.ramping td, .ramping th {
    padding: 0 5px;
}
</style>